import 'bee-checkbox/build/Checkbox.css'
export * from 'bee-checkbox';
export { default } from 'bee-checkbox';


// WEBPACK FOOTER //
// ./src/components/bee/checkbox/index.js